import { useEffect, useState } from 'react';
import { GridPaginationModel } from '@mui/x-data-grid';
import { useDebounce } from 'react-use';

const DEFAULT_PAGE_SIZE = 25;

type Props = {
  pageSize?: number;
};

export const useControlledTableModel = ({ pageSize = DEFAULT_PAGE_SIZE }: Props) => {
  const [skip, setSkip] = useState(0);
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: pageSize,
  });
  useDebounce(() => setDebouncedQuery(query), 300, [query]);

  const handlePageChange = (paginationModel: GridPaginationModel) => {
    setSkip(paginationModel.page * pageSize);
    setPaginationModel(paginationModel);
  };

  return {
    skip,
    query,
    debouncedQuery,
    paginationModel,
    handlers: {
      handlePageChange,
      setQuery,
    },
  };
};

export const useControlledRowStateModel = (totalCount?: number) => {
  const [rowCountState, setRowCountState] = useState(totalCount ?? 0);
  useEffect(() => {
    setRowCountState((prevRowCountState) => (totalCount ? totalCount : prevRowCountState));
  }, [totalCount, setRowCountState]);

  {
    return {
      rowCount: rowCountState,
    };
  }
};
